import CrudManager from "@/components/admin/CrudManager";
import { formatDate } from "@/lib/format";
import { useSeo } from "@/hooks/useSeo";

const AdminKegiatan = () => {
  useSeo("Kelola Kegiatan");
  return (
    <CrudManager
      title="Kegiatan"
      description="Tambah, edit, dan hapus kegiatan sekolah."
      endpoint="/activities"
      prefix="admin-activity"
      columns={[
        { name: "image_url", image: true },
        { name: "title" },
        { name: "meta", render: (i) => `${formatDate(i.date)}${i.location ? " • " + i.location : ""}` },
      ]}
      fields={[
        { name: "title", label: "Nama Kegiatan", type: "text", required: true, full: true, placeholder: "Nama kegiatan" },
        { name: "date", label: "Tanggal", type: "date" },
        { name: "location", label: "Lokasi", type: "text", placeholder: "Lokasi kegiatan" },
        { name: "image_url", label: "Foto Kegiatan", type: "image" },
        { name: "excerpt", label: "Deskripsi Singkat", type: "textarea", rows: 2 },
        { name: "content", label: "Deskripsi Lengkap", type: "textarea", rows: 7 },
      ]}
    />
  );
};

export default AdminKegiatan;
